<template>
  <ul class="budget-chips">
    <li v-for="chip in BUDGET_CHIPS" :key="chip.label">
      <Chip
        role="button"
        tabindex="0"
        :aria-pressed="isSelected(chip)"
        :selected="isSelected(chip)"
        @click="$emit('click-chip', chip)"
        @keydown.enter="$emit('click-chip', chip)"
      >
        {{ chip.label }}
      </Chip>
    </li>
  </ul>
</template>
<script setup>
import Chip from '../../components/atoms/chips/Chip.vue'
import { BUDGET_CHIPS } from './budgetChipConstants.js'

const props = defineProps({
  lowerBudget: { type: Number, default: null },
  higherBudget: { type: Number, default: null }
})

defineEmits(['click-chip'])

// URLの価格条件がチップ定義と完全一致するときだけ選択中とする。
const isSelected = chip =>
  chip.lowerBudget === props.lowerBudget &&
  chip.higherBudget === props.higherBudget
</script>
<style lang="scss" scoped>
.budget-chips {
  display: flex;
  gap: 4px;
  margin: 0;
  list-style: none;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  li {
    flex-shrink: 0;
  }
}
</style>
